import React, { useEffect } from "react";
import styled from '@emotion/styled';
import NoLoginPage from 'components/layout/newOnboarding//NoLogInPage';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui';
import ReactGA from "react-ga4";
import { usePostComplete } from 'hooks/api';
import ReactPixel from 'react-facebook-pixel';



const Elem:React.FC<any> = () => {
  const { mutateAsync: postComplete  } = usePostComplete();
  const navigator = useNavigate();
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
  const medium = localStorage.getItem('medium');

  const handleGotohome = async () => {
    ReactGA.event({
      "category": "Button",
      "action" : "Click",
      "label" : "All step completed: being subscriber"
    })
    const result = await postComplete({
      medium
    })
    if (result.status === 200) {
      navigator('/home')
    } else {
      localStorage.removeItem('token')
    }
  };

  const handleAppStore = async () => {
    window.open("https://apps.apple.com/kr/app/%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%9D%B8%ED%99%94%EA%B5%AC%EB%8F%85/id1619040733", "_blank")
  }

  const handleGoogle = async () => {
    window.open("https://play.google.com/store/apps/details?id=com.photypeta.photypetaApp", "_blank");
  }

  useEffect (() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/onboarding/5/complete", title: "subscribe_complete" })
      ReactPixel.fbq('track', 'Purchase');
    }
  },[]);

  return (
    <NoLoginPage disable={false}>
      <Container>
        <Body>
          <TextContainer>
            <SmallText className="special">환영합니다</SmallText>
            <BigText className="Top">미루지 않는 <br/>인화라이프의 시작 <br/>앱으로 이어가세요</BigText>
          </TextContainer>
          <SmallText className="first">정기구독 플랜</SmallText>
          <SquareContainer>
            <TextWrapper>
              <BigText className="secondType">Basic 플랜</BigText>
            </TextWrapper>
            <TextBox>
              <SmallText className="secondType">무료배송</SmallText>
              <SmallText className="secondType">사진 5장, 내지 1장</SmallText>
              <SmallText className="secondType">클라우드 평생 저장</SmallText>
              <SmallText className="secondType">프리미엄 전용 앨범 1장</SmallText>
              <TextContinerInbox>
                <ContextWrapper>지금 결제 금액</ContextWrapper>
                <SmallTextContainer>
                  <MiddleUnderline>₩8,900원</MiddleUnderline>
                  <ContextWrapper>0원</ContextWrapper>
                </SmallTextContainer>
              </TextContinerInbox>
            </TextBox>
            <ContentWrapper className="top">
              <ImgContainer>
                <Img src="/images/card.png"/>
              </ImgContainer>
              월 ₩8,900
            </ContentWrapper>
            <ContentWrapper className="bottom">
              <ImgContainer>
                <Img src="/images/calender.png"/>
              </ImgContainer>
              7월 25일 갱신예정
            </ContentWrapper>
          </SquareContainer>
          <SmallText className="first">지금 다운로드</SmallText>
          <DownloadButtonWrapper>
            <DownloadButton className="app" onClick={handleAppStore}>
            <LoginImg>
              <Img
                src={"/images/newLanding/home/appstore.png"}
              />
              </LoginImg>
              APP STORE
              </DownloadButton>
            <DownloadButton className="google" onClick={handleGoogle}>
              <LoginImg>
                <Img
                  src={"/images/newLanding/home/googleplay.png"}
                />
              </LoginImg>
              GOOGLE PLAY
            </DownloadButton>
          </DownloadButtonWrapper>
        </Body>
      </Container>
    </NoLoginPage>
  )
}

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 24px 17px;
  background-color: #F5F3EF;
`;
const TextContainer = styled.div`
  width: 220px;
  /* height: 50px; */
  display: flex;
  flex-direction: column;
  margin-bottom: 38px;
`

const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 100%;
  color: #141414;

  @media (max-width:321px) {
    font-size: 10px;
  }
  span {
    font-weight: 700;
  }
  &.first {
    /* margin-top: 6px;
    margin-bottom: 6px; */
  }
  &.Second {
    margin-top: 12.37px;
  }
  &.title {
    font-weight: 500;
    font-size: 14px;
  }
  &.secondType {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 153%;
    color: rgba(137, 137, 137, 1);

    @media (max-width: 321px) {
      font-size: 10px;
    }
  }
  &.special{
    font-size: 13px;
    margin-bottom: 15px;
  }
`;

const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  color: #141414;
  font-weight: bold;

  @media (max-width:321px) {
    font-size: 20px;
  }

  &.Top {
    font-weight: Bold;
    margin-bottom: 5px;
    letter-spacing: -0.03em;
  }

  &.Bottom {
    font-weight: 300;
  }
  &.secondType {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 100%;
    color: #111111;

    @media (max-width:321px) {
      font-size: 20px;
    }
  }

`;
const SquareContainer = styled.div`
  /* max-width: 344px; */
  /* height: 270px; */

  @media (max-width:321px) {
    height: 250px;
  }
  /* background-color: rgba(246, 245, 247, 1); */
  background-color: white;
  border-radius: 10px;
  margin: 15px auto 34px;
  padding: 0 16.33px 0 18.33px;
  display: flex;
  flex-direction: column;
`;

const TextWrapper = styled.div`
  font-family: 'Pretendard';
  max-width: 102px;
  height: 23px;
  margin-top: 32px;
`;
const TextBox = styled.div`
  margin-top: 40px;
`;
const ContextWrapper = styled.div`
  /* max-width: 320px; */
  /* width: 130%; */
  height: 42px;
  /* margin-top: 25px; */
  /* border-top: 1px solid #BCBCBC; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const TextContainerInSquare = styled.div`
  margin-top: auto;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #565656;
`;
const Body = styled.div`
  max-width: 344px;
  width: 100%;
  margin: 0 auto;
`

const SecondContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  /* padding: 0 10px; */
`;

const MiddleUnderline = styled.span`
  position: relative;
  display: inline-block;
  margin-right: 22.24px;
  color: #7E7E7E;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 20%;
    border-bottom: 1px solid #7E7E7E; /* 밑줄의 색과 두께를 조정합니다 */
    transform: translateY(-50%);
  }
`;

const SmallTextContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ContentWrapper =styled.div`
  width:100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  &.top{
    
    margin-top: 20.3px;
  }

  &.bottom {
    margin-top: 7.86px;
    margin-bottom: 19.52px;
  }
`

const ImgContainer = styled.div`
  width: 13.52px;
  height: 12.42px;
  margin-right: 10.29px;

  &.pay{
    width: 20px;
    margin-right: 30.12px;
  }

  &.kakao {
    width: 60px;
    /* height: 40px; */
    margin-right: 15.12px;
  }

`
const Img = styled.img`
  width: 100%;
  /* height: 100%; */
`
const TextContinerInbox = styled.div`
  width: 100%;
  display: flex;
  /* min-height: 30px; */
  justify-content: space-between;
  margin-top: 13.72px;
  border-bottom: 1px solid #DCDCDC;
  align-items: start;
`


const DownloadButtonWrapper = styled.div`
  margin: 9px auto;
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
`;
const DownloadButton = styled.button`
  width: 48%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 500;
  background-color: #DBC6A7;
  color: black;

  &.app{
    margin-right: 10px;
  }

  ;&.google {}
`
const LoginImg = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;